<template>
  <footer id="discussionFooter" class="article__footer">
    <button class="discussion-btn thumbs-up" :disabled="makingApiCall" @click.prevent="toggleLike">
      <span aria-hidden="true" :class="likeClass" />{{ likeCount }} Like
    </button>

    <div v-if="showMoreOptions" :class="['more-options', { 'multiple-options': isOwner }]">
      <button v-if="isOwner" class="btn -link" @click="redirectEdit">
        Edit Discussion
      </button>
      <button v-if="isOwner" class="btn -link" @click="openConfirmModal">
        Remove Discussion
      </button>
      <button v-if="!isOwner" class="btn -link" @click="openFlagModal">
        Report Spam or Abuse
      </button>
    </div>

    <button v-if="isLoggedIn" class="btn-more" @click="() => (showMoreOptions = !showMoreOptions)">
      <i class="f" />
      <i class="m" />
      <i class="l" />
    </button>

    <modal-flag
      v-if="isFlagModalOpen"
      :id="id"
      :flaggable-type="type"
      :handle-close-click="closeFlagModal"
    />

    <modal-confirm
      v-if="isConfirmModalOpen"
      heading="Remove Discussion"
      subheading="Are you sure you want to remove this discussion?  All comments on it will be removed as well."
      button-text="Remove"
      :handle-close-click="closeConfirmModal"
      :url="`/community/remove/${id}`"
    />
  </footer>
</template>

<script>
// @flow
import { mapState, mapActions } from 'vuex'
import modalConfirm from 'app/components/modals/modal-confirm.vue'
import modalFlag from 'app/components/modals/modal-flag.vue'
import { fbAPIPost } from 'app/utils/http-api'

export default {
  components: { modalFlag, modalConfirm },
  data() {
    return {
      isFlagModalOpen: false,
      isConfirmModalOpen: false,
      showMoreOptions: false,
      makingApiCall: false,
      type: 'discussion',
    }
  },
  computed: {
    isOwner() {
      return this.user.id === this.authorId
    },
    likeClass() {
      return 'iconfont' + (this.isLiked ? '-like-select' : '-like')
    },
    ...mapState({
      // pull in all the article fields.  Maybe should just get the article object
      // or maybe pull out of Vuex since these are all just used in this component currently
      id: (state: State) => state.article.id,
      authorId: (state: State) => state.article.authorId,
      isLiked: (state: State) => state.article.isLiked,
      likeCount: (state: State) => state.article.likeCount,
      user: (state: State) => state.user,
      isLoggedIn: (state: State) => state.user.isLoggedIn,
    }),
  },
  methods: {
    openFlagModal() {
      this.isFlagModalOpen = true
    },
    redirectEdit() {
      window.location = `/community/edit/${this.id}`
    },
    closeFlagModal() {
      this.isFlagModalOpen = false
      // issue with trying to close showMore in openFlagModal so move here
      this.showMoreOptions = false
    },
    // similar function in comment.vue
    toggleLike() {
      if (!this.isLoggedIn) {
        this.showLoginModal()
        return
      }

      const apiCall = this.isLiked ? 'remove' : 'add'
      this.setLikeAndCounter(!this.isLiked)
      this.makingApiCall = true

      const formData = new window.FormData()
      formData.append('likeable_type', this.type)
      formData.append('likeable_id', this.id)

      fbAPIPost(
        `like/${apiCall}`,
        formData,
        res => {
          this.makingApiCall = false
        },
        errr => {
          this.makingApiCall = false
          // undo like
          this.setLikeAndCounter(!this.isLiked)
        },
      )
    },
    openConfirmModal() {
      this.showMoreOptions = false
      this.isConfirmModalOpen = true
    },
    closeConfirmModal() {
      this.isConfirmModalOpen = false
    },
    ...mapActions(['showLoginModal', 'setLikeAndCounter']),
  },
}
</script>
